<template>
  <div class="supply">
    
    <div class="frame">
      <div class="big-title">
        <p>运营框架</p>
        <div class="line"></div>
        <div class="desc">
          将“供应商-生产商-经销商-消费者”紧密链接，提高网商服务能力，为消费者提供新的电子交易规则
        </div>
      </div>
      <img src="../../static/images/solution/onlineShopFrame.png" alt="" />
    </div>
    
    <div class="system">
      <div class="big-title">
        <p>系统功能</p>
        <div class="line"></div>
        <div class="desc">
          站在用户立场，打造符合商家用户操作习惯与业务需求的电商系统对每一个功能都精雕细琢
        </div>
      </div>
      <div class="system-box">
        <div class="system-item" v-for="item in systemArr" :key="item.id">
          <img :src="item.img" alt="" />
          <div>
              <h5>{{ item.title }}</h5>
              <h6>{{ item.desc }}</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="hard">
      <div class="big-title">
        <p>多种营销方式</p>
        <div class="line"></div>
        <div class="desc">
          利用营销方式的多样化增加用户粘性，促进运营推广
        </div>
      </div>
      <div class="hard-box">
        <div class="hard-item" v-for="item in hardArr" :key="item.id">
          <img :src="item.img" alt="" />
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="value">
      <div class="big-title">
        <p>多种应用模式</p>
        <div class="line"></div>
        <div class="desc">
          丰富多彩的应用模式，满足企业平台的不同需求
        </div>
      </div>
      <ul class="modeList">
        <li :class="{'modeActive' : modeIndex==0}" @click="modeIndex=0">多商城系统自营模式</li>
        <li :class="{'modeActive' : modeIndex==1}" @click="modeIndex=1">多用户商城联营模式</li>
        <li :class="{'modeActive' : modeIndex==2}" @click="modeIndex=2">多店商城招商模式</li>
        <li :class="{'modeActive' : modeIndex==3}" @click="modeIndex=3">多用户购物商城自营+招商模式</li>
      </ul>
      <div class="modeCont">
        <img :src="modeList[modeIndex].img" alt="" />
        <div class="modeContText">
          <h5>{{modeList[modeIndex].title}}</h5>
          <p>{{modeList[modeIndex].cont}}</p>
          <h6  @click="jumpService">立即咨询</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hardArr: [
        {
          id: 0,
          img: require("../../static/images/solution/yingxiaohuodong.png"),
          title: "营销活动",
          desc: "贴合时事、热点，创建自定义活动，通过多种营销互动模式，快速推广产品",
        },
        {
          id: 1,
          img: require("../../static/images/solution/cuxiaotuiguang.png"),
          title: "促销推广",
          desc: "多种活动促销方式，刺激会员积极参与活动，在社交网络形成爆炸式传播",
        },
        {
          id: 2,
          img: require("../../static/images/solution/guiyuanzhuanghua.png"),
          title: "会员转化",
          desc: "通过分销、优惠、便捷支付等多种途径，快速发展万人团队，实现会员转化",
        },
        {
          id: 3,
          img: require("../../static/images/solution/huiyuanyingxiao.png"),
          title: "会员营销",
          desc: "分析、统计会员消费习惯，执行针对会员的场景化营销，提升平台与会员之间的粘性",
        },
        {
          id: 4,
          img: require("../../static/images/solution/xitongguanli.png"),
          title: "系统管理",
          desc: "一站式管理平台、商家、会员，整合线上线下资源，实现双向发展",
        },
      ],
      systemArr: [
        {
          id: 0,
          title:'店铺管理',
          desc: "店铺管理、店铺运营、续约结算、多维度运营数据、财务管理、类目佣金设置",
          img: require("../../static/images/solution/dianpuguanli.png"),
        },
        {
          id: 1,
          title:'交易管理',
          desc: "订单管理、退款处理、退货处理、交易评价、交易投诉、支付方式",
          img: require("../../static/images/solution/jiaoyiguanli.png"),
        },
        {
          id: 2,
          title:'分销管理',
          desc: "分销页面设置、自定义佣金、划分代理商等级、分销业绩管理、分销报表分析、销售员管理",
          img: require("../../static/images/solution/fenxiaoguanli.png"),
        },
        {
          id: 3,
          title:'会员管理',
          desc: "会员管理、标签管理、会员营销、会员积分、积分规划、会员等级、会员推广",
          img: require("../../static/images/solution/huiyuan2.png"),
        },
        {
          id: 4,
          title:'营销管理',
          desc: "商家促销工具、平台互动营销、平台营销专题、分享传播、营销效果分析",
          img: require("../../static/images/solution/yingxiaoguanli.png"),
        },
        {
          id: 6,
          title:'统计管理',
          desc: "会员统计、店铺统计、销量分析、转化分析、决策支持",
          img: require("../../static/images/solution/tongjiguanli.png"),
        },
      ],
      modeIndex:0,//选中的模式
      //模式列表
      modeList:[
        {
          img:require("../../static/images/solution/mode1.png"),
          title:'多商城系统自营模式',
          cont:'企业平台建立线上B2B2C商城系统，整合多种自身渠道业务。通过会员、商品、订单、账务和仓储管理系统，对B2B2C商城线上线下多种渠道进行统一管理',
        },{
          img:require("../../static/images/solution/mode3.png"),
          title:'多用户商城联营模式',
          cont:'多个渠道供应商一起合作经营，以商品入库、统一仓储、统一物流的方式进入库联营。多用户商城平台企业通过供销或直销的方式，将供应商资源纳入多用户商城平台自营体系，建立多个自营店铺，多样化商品和服务种类，进行资源整合。',
        },{
          img:require("../../static/images/solution/mode4.png"),
          title:'多店商城招商模式',
          cont:'多店铺商城系统企业签约多个渠道供应商，通过会员、交易、平台和财务管理系统，对多店商城网站进行管理，多个渠道供应商，以签约加盟的方式，入驻B2B2C商城平台',
        },{
          img:require("../../static/images/solution/mode2.png"),
          title:'多用户购物商城自营+招商模式',
          cont:'B2B2C系统企业整合多个渠道业务，通过会员、商品、订单、财务和仓储管理系统，入驻商家可自行对商品订单等进行管理，定期与多用户商城平台进行账务结算',
        },
      ],
    };
    },
    methods:{
      //立即咨询
    jumpService() {
      this.$addConsult()
    },
  },
};
</script>

<style lang="stylus" scoped>
.supply {
  margin: 80px 0 80px;
}

.hard {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .hard-box {
    display: flex;
  }

  .hard-item {
    box-sizing: border-box;
    padding: 0 40px;
    width: 262px;
    height: 302px;
    background: #F7F7F7;
    border-radius: 8px;
    margin-right: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h2 {
      margin-top: 20px;
      margin-bottom: 30px;
      font-size: 20px;
      font-weight: bold;
      color: #333333;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      text-align: center;
    }
  }
}

.frame, .value {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;
}
.modeList{
  display :flex ;
  justify-content :center
  align-items :center
  li{
    // width: 192px;
    padding:0 20px;
    height: 46px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    line-height: 46px;
    text-align :center
    margin :0 40px 
  }
  .modeActive{
    background: #FFC000;
    border-radius: 23px;
    color: #FFFFFF;
  }
}
.modeCont{
  display :flex;
  justify-content :center
  margin:27px;
  img{
    width :316px;
    height :365px;
  }
  .modeContText{
    width:368px;
    margin :73px 0 0 155px
    h5{
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    p{
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      line-height: 32px;
      margin:39px 0
    }
    h6{
      width: 100px;
      height: 40px;
      background: #FFC000;
      border-radius: 4px;
      line-height :40px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      text-align :center
      line-height :40px
    }
  }
}

.system {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .system-box {
    display: flex;
    flex-wrap: wrap;
    justify-content :space-between
  }

  .system-item {
    width: 451px;
    height: 132px;
    padding :24px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 4px;
    margin-bottom: 24px;
    display: flex;
    justify-content: flex-start;
    img{
      width :40px;
      height :40px
      margin:0 20px 0 0
    }

    p {
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      margin-top:40px;
    }
    h5{
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin :0 0 23px 0
    }
    h6{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
  }

  .system-item:hover {
    box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
  }
}

.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

  .line {
    width: 42px;
    height: 2px;
    background: #FFC000;
    border-radius: 1px;
    margin-top: 29px;
  }

  .desc {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 22px 0 58px;
    line-height: 28px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/solutionOnlineShop.vue